export const extractLinkedInVanity = (url) => {
  if (!url) return null;

  // Remove protocol, www, trailing slashes, query params
  let cleanUrl = url
    .replace(/^https?:\/\//, "")
    .replace(/^www\./, "")
    .replace(/\/$/, "")
    .split("?")[0]
    .split("#")[0];

  // Extract vanity from different LinkedIn URL formats
  const patterns = [
    /linkedin\.com\/in\/([^\/\?]+)/i, // linkedin.com/in/johndoe
    /linkedin\.com\/profile\/view\?id=([^&]+)/i, // old format
    /linkedin\.com\/pub\/[^\/]+\/[^\/]+\/[^\/]+\/([^\/\?]+)/i, // pub format
  ];

  for (const pattern of patterns) {
    const match = cleanUrl.match(pattern);
    if (match && match[1]) {
      return match[1].toLowerCase().trim();
    }
  }

  return null;
};

// Test cases:
// "https://www.linkedin.com/in/johndoe/" → "johndoe"
// "linkedin.com/in/johndoe?utm_source=share" → "johndoe"
// "https://linkedin.com/in/jane-smith-123/" → "jane-smith-123"
